import { useEffect } from "react";

const useKeyDown = (codeHandlers: Record<string, (e: KeyboardEvent) => void>, opts?: { skip?: boolean }): void => {
  useEffect(() => {
    if (opts?.skip) return;
    const listener = (e: KeyboardEvent) => {
      const handler = codeHandlers[e.code];
      if (!handler) return;
      handler(e);
    };
    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
  });
};

export default useKeyDown;
